import { Link } from "react-router-dom";
import { Building2, ArrowRight } from "lucide-react";

export default function BusinessSummary({ profile, isFree }) {
  const hasProfile = profile && profile.org_name;
  return (
    <div className="rounded-xl border border-slate-200 bg-white p-6">
      <h2 className="font-heading text-lg font-bold text-[#0A0F1C]">Your Business</h2>
      {hasProfile ? (
        <div className="mt-4 space-y-3">
          <div className="flex items-center gap-3">
            <div className="h-11 w-11 rounded-lg bg-[#0A0F1C] flex items-center justify-center">
              <Building2 size={18} className="text-white" />
            </div>
            <div className="min-w-0">
              <p className="font-medium text-[#0A0F1C] truncate">{profile.org_name}</p>
              <p className="text-xs text-slate-500 capitalize">{profile.org_type?.replace("_", " ")}</p>
            </div>
          </div>
          <p className="text-sm text-slate-600 line-clamp-3">{profile.description}</p>
          <Link to="/profile" className="text-sm text-[#2563EB] font-medium flex items-center gap-1" data-testid="edit-profile-link">Edit profile <ArrowRight size={14} /></Link>
        </div>
      ) : (
        <p className="mt-4 text-sm text-slate-500">No profile yet.</p>
      )}
      {isFree && (
        <Link to="/pricing" className="mt-5 block rounded-lg bg-[#2563EB]/5 border border-[#2563EB]/20 p-4" data-testid="upgrade-prompt">
          <p className="font-medium text-[#0A0F1C] text-sm">Unlock unlimited matches</p>
          <p className="text-xs text-slate-500 mt-0.5">Upgrade to Professional → <span className="text-[#2563EB] font-medium">$49/mo</span></p>
        </Link>
      )}
    </div>
  );
}

export function ProfileBanner() {
  return (
    <div className="mb-6 rounded-xl border border-amber-200 bg-amber-50 p-5 flex items-start gap-3" data-testid="profile-incomplete-banner">
      <Building2 className="text-amber-600 shrink-0" size={20} />
      <div className="flex-1">
        <p className="font-medium text-amber-900">Complete your business profile</p>
        <p className="text-sm text-amber-800 mt-0.5">AI matching needs your profile to find the right opportunities.</p>
      </div>
      <Link to="/profile" data-testid="complete-profile-cta" className="h-10 px-4 rounded-md bg-amber-600 text-white text-sm font-medium flex items-center hover:bg-amber-700 transition-colors shrink-0">Set up now</Link>
    </div>
  );
}
